import Enum from '@square/dashboard-utilities/utils/enum';
/**
 * Invoices/Enums
 *
 * This file contains enums used by different invoices/ models.
 *
 * TODO: Eventually we'll refactor our models to use the enums from
 * @square/dashboard-protos/ directly and we'll remove this file and any
 * enums defined in other invoices/ model files.
 */

/**
 * Types for this model are defined here: @dashboard/invoices-shared/types/model
 */

// squareup.bills.ApplicationScope
export const ApplicationScope = new Enum(['UNKNOWN', 'ITEMIZATION_LEVEL', 'CART_LEVEL', 'CART_LEVEL_FIXED', 'ITEMIZATION_LEVEL_PER_QUANTITY']);

// squareup.api.items.CalculationPhase
export const CalculationPhase = new Enum(['DISCOUNT_PERCENTAGE_PHASE', 'DISCOUNT_AMOUNT_PHASE', 'FEE_SUBTOTAL_PHASE', 'FEE_TOTAL_PHASE', 'TIP_PHASE', 'SWEDISH_ROUNDING_PHASE', 'SURCHARGE_PHASE', 'SURCHARGE_TOTAL_PHASE', 'APPORTIONED_SURCHARGE_PERCENTAGE_PHASE', 'APPORTIONED_SURCHARGE_AMOUNT_PHASE', 'CARD_SURCHARGE_PHASE']);

// squareup.items.merchant.CatalogObjectType
export const CatalogObjectType = new Enum(['DO_NOT_USE', 'ITEM', 'ITEM_IMAGE', 'PAGE_TILE', 'CATEGORY', 'ITEM_VARIATION', 'FEE', 'PLACEHOLDER', 'DISCOUNT', 'ITEM_FEE_MEMBERSHIP', 'ITEM_MODIFIER_LIST', 'ITEM_ITEM_MODIFIER_LIST_MEMBERSHIP', 'ITEM_MODIFIER_OPTION', 'MARKET_ITEM_SETTINGS', 'ADDITIONAL_ITEM_IMAGE', 'PROMO', 'INVENTORY_INFO', 'OBSOLETE_TENDER_FEE', 'DINING_OPTION', 'TAX_RULE', 'CONFIGURATION', 'PAGE', 'TICKET_GROUP', 'TICKET_TEMPLATE', 'VOID_REASON', 'ITEM_VARIATION_VENDOR_INFO', 'MENU', 'TAG', 'FLOOR_PLAN', 'FLOOR_PLAN_TILE', 'FAVORITES_LIST_POSITION', 'MENU_GROUP_MEMBERSHIP', 'SURCHARGE', 'PRICING_RULE', 'PRODUCT_SET', 'TIME_PERIOD', 'SURCHARGE_FEE_MEMBERSHIP', 'MEASUREMENT_UNIT', 'SUBSCRIPTION_PLAN', 'ITEM_OPTION', 'ITEM_OPTION_VAL', 'CUSTOM_ATTRIBUTE_DEFINITION', 'CUSTOM_ATTRIBUTE_SELECTION', 'QUICK_AMOUNTS_SETTINGS', 'QUICK_AMOUNT', 'COMPONENT', 'COMPOSITION', 'RESOURCE', 'SUBSCRIPTION_PHASE', 'OBJECT_IMAGE_MEMBERSHIP', 'CHECKOUT_LINK', 'CHECKOUT_LINK_LINE_ITEM', 'PRODUCT', 'PRODUCT_FAMILY', 'CATALOG', 'CONSTRAINT', 'ATTRIBUTE_DEFINITION_METADATA', 'RECIPE', 'INGREDIENT']);

// squareup.api.items.Fee.InclusionType
export const InclusionType = new Enum(['ADDITIVE', 'INCLUSIVE']);

// squareup.api.items.Surcharge.Type
export const SurchargeType = new Enum(['UNKNOWN', 'AUTO_GRATUITY', 'CUSTOM']);

// squareup.bills.TranslatedName.TranslationType
export const TranslationType = new Enum(['UNKNOWN', 'CUSTOM_AMOUNT_ITEM', 'UNITEMIZED_TAX', 'DEFAULT_DISCOUNT', 'DEFAULT_ITEM', 'DEFAULT_SALES_TAX', 'DEFAULT_TIP', 'CHANGE', 'REFUND', 'CASH_REFUND', 'INCLUSIVE_TAX', 'DEFAULT_ITEM_MODIFIER', 'CREDIT']);

// squareup.api.items.Surcharge.TreatmentType
export const TreatmentType = new Enum(['LINE_ITEM', 'APPORTIONED']);